import React from 'react';

import { ITabsBaseProps } from 'views/Offers/BuyOneGetMany/Form/BuyOneGetManyForm.types';

import { SubOffersList } from '../SubOfferCard';

const ConfigurationTab: React.FC<ITabsBaseProps> = ({
  buyOneGetManyId,
  productsSequence,
  setProductsSequence,
  setBarPointsValidity,
  relevantBadgeType,
  progressBarOffers
}): React.ReactElement => {
  return (
    <SubOffersList
      buyOneGetManyId={buyOneGetManyId}
      productsSequence={productsSequence}
      setProductsSequence={setProductsSequence}
      setBarPointsValidity={setBarPointsValidity}
      relevantBadgeType={relevantBadgeType}
      progressBarOffers={progressBarOffers}
    />
  );
};

export default ConfigurationTab;
